import type { User } from "@repo/baseCloud";
import type { GridList } from "@repo/ui";

import { BaseController, BaseGridApi } from "@repo/baseCloud";
import { Complaint, ComplaintAffiliatePartner } from "@repo/models";

import type {
	ComplaintOrIncidentOption,
	ComplaintSource,
	ComplaintType,
	ComplaintsFilter,
	ReportingTag,
} from "../models";

export const controller = "CustomerIncidents";
const gridFiltersController = "GridFilters";

export default class ComplaintsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);
	static GetGridFilters = BaseController.GetFn(gridFiltersController);

	/** Loads all complaints matching filters */
	static getComplaints(filter: ComplaintsFilter) {
		return ComplaintsApi.Get<GridList<Complaint>>("GetComplaints", filter);
	}

	/** Gets complaint types for dropdown */
	static getComplaintTypes() {
		return ComplaintsApi.Get<ComplaintType[]>("GetComplaintTypes");
	}

	/** Gets complaint sources for dropdown */
	static getComplaintSources() {
		return ComplaintsApi.Get<ComplaintSource[]>("GetComplaintSources");
	}

	/** Gets users for QA Analyst dropdown */
	static getUsers() {
		return ComplaintsApi.GetGridFilters<User[]>("GetUsers");
	}

	/** Gets reporting tags for dropdown */
	static getReportingTags(branchIds?: number[]) {
		return ComplaintsApi.Get<ReportingTag[]>("GetReportingTags", { branchIds });
	}

	/** Gets Online Affiliates partners, one per brand they sell; empty where no partners are set up */
	static getAffiliatePartners() {
		return ComplaintsApi.Get<ComplaintAffiliatePartner[]>("GetAffiliatePartners");
	}

	/** Gets complaint or incident options for dropdown */
	static getComplaintOrIncident() {
		return ComplaintsApi.Get<ComplaintOrIncidentOption[]>("GetComplaintOrIncident");
	}

	/** Deletes a complaint. Only the id goes in the body; the whole row in the query string would exceed the URL limit. */
	static deleteComplaint(complaint: Complaint) {
		return ComplaintsApi.Post("Delete", {}, { id: complaint.id });
	}

	/** Loads saved grid settings for complaints */
	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Customer Incidents");
	}

	/** Saves grid settings for complaints. Pass empty string to clear. */
	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Customer Incidents", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "CustomerIncident");
	}
}
